import React from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { authApi } from '../api';
import { LoginRequest } from '../types';

const { Title } = Typography;

const Login: React.FC = () => {
  const navigate = useNavigate();
  const { setUser } = useAuthStore();

  const loginMutation = useMutation(
    (data: LoginRequest) => authApi.login(data),
    {
      onSuccess: async (response) => {
        const { access_token } = response.data;
        localStorage.setItem('access_token', access_token);
        
        // 获取用户信息
        try {
          const userResponse = await authApi.getCurrentUser();
          setUser(userResponse.data);
          message.success('登录成功');
          navigate('/');
        } catch (error) {
          message.error('获取用户信息失败');
        }
      },
      onError: () => {
        message.error('用户名或密码错误');
      },
    }
  );

  const onFinish = (values: LoginRequest) => {
    loginMutation.mutate(values);
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    }}>
      <Card 
        style={{ 
          width: 400, 
          boxShadow: '0 10px 25px rgba(0,0,0,0.1)',
          borderRadius: '10px',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <Title level={2} style={{ color: '#1890ff' }}>
            小红书监控系统
          </Title>
          <p style={{ color: '#666' }}>请登录您的账户</p>
        </div>

        <Form
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input 
              prefix={<UserOutlined />} 
              placeholder="用户名" 
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password 
              prefix={<LockOutlined />} 
              placeholder="密码" 
            />
          </Form.Item>

          <Form.Item>
            <Button 
              type="primary" 
              htmlType="submit" 
              loading={loginMutation.isLoading}
              style={{ width: '100%' }}
            >
              登录
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login; 